<rfx-grid-filter-control>
	<button
		mat-button
		type="button"
		(click)="clearFilters()"
	>{{'COMMON.CLEAR_FILTERS'|translate}}
	</button>
</rfx-grid-filter-control>
